import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IExpenseAccount } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ExpenseAccountService extends BaseService<IExpenseAccount> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'expenseAccount');
  }
}

export { IExpenseAccount, ExpenseType } from '../shared/api';
